// sbKey → the line-item name that was auto-applied there, so a harmless remount can be told apart
// from a genuine item change (upload/rename).
export const appliedNameBySbKey = new Map<string, string>();

export const setAppliedName = (sbKey: string, name: string): void => { appliedNameBySbKey.set(sbKey, name); };
